import React, { FunctionComponent } from "react";
import { Grid, TextField, IconButton } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import DeleteIcon from '@material-ui/icons/Delete';
import { IDynamicFormExtenderChildren } from "../yoello-lib/modules/dynamicForms/DynamicFormExtender";

interface IURLRangeProps extends IDynamicFormExtenderChildren {
    url: string;
    label: string;
}
/**Handles the table ranges form */
const URLRange: FunctionComponent<IURLRangeProps> = ({ index, onChangeHandler, onDeleteHandler,
    url, label, disabled }) => {
    const { t } = useTranslation();
    const onChange = (ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const key = ev.target.name;
        const value = ev.target.value;
        onChangeHandler(index, key, value);
    };


    return <>
        <Grid item xs={7}>
            <TextField 
                type="url" 
                label={t('merchant.urls.url')} 
                variant={'outlined'} 
                fullWidth 
                name="url" 
                onChange={onChange} 
                value={url} 
                disabled={disabled}
            />
        </Grid>
        <Grid item xs={4}>
            <TextField 
                label={t('merchant.urls.name')} 
                variant={'outlined'} 
                fullWidth 
                name="label" 
                onChange={onChange} 
                value={label} 
                disabled={disabled}
            />
        </Grid>
        <Grid item xs={1}>
            {onDeleteHandler ?
                <IconButton
                    onClick={() => onDeleteHandler(index)} 
                    aria-label="delete" 
                    color="secondary"
                    disabled={disabled}
                >
                    <DeleteIcon />
                </IconButton> : null}
        </Grid>
    </>;

};

export default URLRange;